import React from 'react'
import { useCreateAchSource } from '../useCreateAchSource'
import { PrintGenerated } from './PrintGenerated'
import { GenerateBankInfo } from './GenerateBankInfo'
import { useContext } from './Context'
import { DataSuspense, ShowIf } from '@ztechapps/webui.util'
import { generateId } from '@ztechapps/common.utils'
import { useUser } from '@ztechapps/common.hook'
import { useCheckoutContext } from '../../../index'

export const Layout = () => {
  const context = useCheckoutContext()

  const [bankInfo, setBankInfo] = React.useState(null)
  //const { createAchSourceUrl, fromCheckout } = useParentContext()
  const fromCheckout = context.fromCheckout
  const createAchSourceUrl = context.createAchSourceUrl
  const { document } = context.orderDocumentResult
  const { amount: achAmount, isPartial, errors } = useContext()

  const [createBankInfo, { error, loading }] = useCreateAchSource(createAchSourceUrl) as [
    ({ amount, email, metadata }) => Promise<any>,
    { error: any; loading: boolean },
  ]
  const [email, setEmail] = React.useState('')
  const { user } = useUser()

  React.useEffect(() => {
    //during development the email address is the testing account
    //amount_{CUSTOM_AMOUNT}@example.com
    const email = document?.by?.profile?.email

    setEmail(email)
  }, [document?.by?.profile?.email])

  const onGenerate = async () => {
    const amount = achAmount
    const metadata = {
      orderId: document?._id,
      orderCode: document?.code,
      userId: user?._id,
      paymentId: generateId(),
      fromCheckout,
    }
    const input = { amount, email, metadata }

    //call the http endpoint for creating source
    const achInfo = await createBankInfo(input)

    setBankInfo(achInfo)
  }

  return (
    <DataSuspense {...{ error, loading }}>
      <ShowIf condition={!bankInfo}>
        <GenerateBankInfo
          onClick={onGenerate}
          email={email}
          setEmail={setEmail}
          disabled={(isPartial && !achAmount) || errors?.amount}
        />
      </ShowIf>
      <ShowIf condition={bankInfo}>
        <PrintGenerated bankInfo={bankInfo} />
      </ShowIf>
    </DataSuspense>
  )
}
